import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {LoadingIndicator} from 'mclane-apptemplate-lib';
@Injectable({
    providedIn: 'root'
})
export class LoadingIndicatorHelper {

    public isLoading: Observable<boolean>;
    public loaderActive: boolean;

    constructor(private _loadingService: LoadingIndicator) {
        this.isLoading = this._loadingService.isLoading;
    }

    show(options: any) {
        return setTimeout(() => {
            this._loadingService.show();
        })
    }

    hide() {
        return setTimeout(() => {
            this._loadingService.hide();
        })
    }

}
